import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import MarketInAMinutePrint from "./MarketInAMinutePrint";
import CallToActionJune from "./CallToActionJune";
import MiniTablePro from "views/PmaAdmin/MiniTablePro";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";
import "./print.scss";
import "./editor.scss";

const MarketInAMinuteEditor = React.lazy(
  () => import("./MarketInAMinuteEditor"),
);

class MarketInAMinute extends Component {
  render() {
    const {
      printVersion,
      currentArea,
      quarterlyAreaTable,
      hoData,
      agentData,
      miniTableDetailsDTO,
      useExtendedTable,
      fromEditor,
      showAllEditButtons,
      keyMarketAvgsList,
    } = this.props;
    const { listgenUserID } = agentData;
    let useDoubleNumbers = false;
    if (listgenUserID === "102512") {
      useDoubleNumbers = true;
    }
    console.log("market in a minute props", this.props);

    const hotBoxesBackground =
      "https://d2onbxnrte2nim.cloudfront.net/non-covers/102026_PMA-DashboardBG-Icons_short.png";
    return (
      <div
        className={`${printVersion ? "print" : "editor"}-qv4-second-left market-in-a-minute`}
      >
        <div
          className={`market-in-a-min-page ${fromEditor ? "from-editor" : ""}`}
          style={{
            backgroundImage: `url(${hotBoxesBackground})`,
          }}
        >
          {fromEditor ? (
            <Suspense fallback={null}>
              <MarketInAMinuteEditor
                keyMarketAvgsList={keyMarketAvgsList}
                currentArea={currentArea}
                quarterlyAreaTable={quarterlyAreaTable}
                agentData={agentData}
                showAllEditButtons={showAllEditButtons}
              />
            </Suspense>
          ) : (
            <MarketInAMinutePrint
              keyMarketAvgsList={keyMarketAvgsList}
              currentArea={currentArea}
              quarterlyAreaTable={quarterlyAreaTable}
            />
          )}
          <MiniTablePro
            currentArea={currentArea}
            quarterlyAreaTable={quarterlyAreaTable}
            hoData={hoData}
            agentData={agentData}
            printVersion={!fromEditor}
            fromEditor={fromEditor}
            miniTableDetailsDTO={miniTableDetailsDTO}
            useExtendedTable={useExtendedTable}
            tableMonthStyles="november-table-container"
            hideSubtitleRow
            showAllEditButtons={showAllEditButtons}
          />

          <QVFourEmailAndWebsiteFooter
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  miniTableDetailsDTO: state.pma.miniTableDetailsDTO,
  keyMarketAvgsList: state.pma.keyMarketAvgsList,
});

const mergeProps = (stateProps, _dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  miniTableDetailsDTO:
    ownProps.miniTableDetailsDTO ?? stateProps.miniTableDetailsDTO,
  keyMarketAvgsList: ownProps.keyMarketAvgsList ?? stateProps.keyMarketAvgsList,
});

export default connect(mapStateToProps, null, mergeProps)(MarketInAMinute);
